<script>
    import Dialog, {Title, Content, Actions, InitialFocus} from '@smui/dialog';
    import Button, {Group, GroupItem, Label, Icon} from '@smui/button';
    import { createEventDispatcher } from 'svelte';

    let eventDialog;
    const dispatch = createEventDispatcher();

    function onYes() {
        dispatch('confirm');
    }

    function onNo() {
        dispatch('decline');
    }

    export function open() {
        eventDialog.setOpen(true);
    }

</script>

<Dialog bind:this={eventDialog}>
    <Title id="title">Let op
    </Title>
    <Content id="content">
        Sla uw gegevens eerst op voordat u andere persoonsgegevens wilt bewerken
    </Content>
    <Actions>
        <Button on:click={onNo} class="cancel-button">
            <Label>annuleren</Label>
        </Button>
        <Button on:click={onYes}>
            <Label>Verwijder gegevens</Label>
        </Button>
    </Actions>
</Dialog>
